import React from "react";

import { OperationsWrapper, StyledIconButton } from "./calculatedFieldStyles";

export const OperationsBar = props => {
  const { calculation, onSetOperation } = props;

  return (
    <OperationsWrapper>
      <StyledIconButton
        onClick={() => onSetOperation(calculation, "multiplication")}
        isSelected={calculation.operation === "multiplication"}
        type="button"
        variant="contained"
        color="primary"
        className="button-icon"
      >
        &#215;
      </StyledIconButton>
      <StyledIconButton
        onClick={() => onSetOperation(calculation, "division")}
        isSelected={calculation.operation === "division"}
        type="button"
        variant="contained"
        color="primary"
        className="button-icon"
      >
        &#247;
      </StyledIconButton>
      <StyledIconButton
        onClick={() => onSetOperation(calculation, "subtraction")}
        isSelected={calculation.operation === "subtraction"}
        type="button"
        variant="contained"
        color="primary"
        className="button-icon"
      >
        &#8722;
      </StyledIconButton>
      <StyledIconButton
        onClick={() => onSetOperation(calculation, "addition")}
        isSelected={calculation.operation === "addition"}
        type="button"
        variant="contained"
        color="primary"
        className="button-icon"
      >
        &#43;
      </StyledIconButton>
    </OperationsWrapper>
  );
};

export default OperationsBar;
